import { Box } from '@mui/material'
import { useFormik } from 'formik'
import React, { useContext, useMemo, useState } from 'react'

import * as styled from './Common.styled'

import {
  Button,
  ButtonColor,
  ButtonSize,
  InputProperty,
  inputs,
  Loader,
  LoaderVariant,
  ModalActions,
  validate,
} from 'components'
import { ProgressContext, ProjectContext } from 'context'
import { ProjectsService } from 'services/projects'
import { ValueType } from 'utils'
import { Terms } from './Terms'

interface Props {
  close: () => void
  token?: string
}

export const Code: React.FC<Props> = ({ close, token }) => {
  const { toast } = useContext(ProgressContext)
  const {
    project: { id },
  } = useContext(ProjectContext)
  const [wait, setWait] = useState(false)

  const formik = useFormik({
    initialValues: { otp: null },
    validate: data => validate(data, properties),
    onSubmit: data => {
      const { otp } = data
      if (token && otp) {
        setWait(true)
        ProjectsService.updateAppstoreSession(id, token, otp)
          .catch(err => toast(err))
          .finally(() => setWait(false))
      }
    },
  })

  const properties = useMemo(
    (): InputProperty[] => [
      {
        name: 'otp',
        type: ValueType.string,
        position: 0,
        isRequired: true,
        title: 'Verification code',
      },
    ],
    []
  )

  return wait ? (
    <Box height="388px">
      <Loader variant={LoaderVariant.DOTS} />
    </Box>
  ) : (
    <>
      <styled.SubTitle>
        Apple requested two-factor verification. You may see a push prompt on your Apple device from an unfamiliar
        location - not to worry, this is from CodePlatform. Accept the prompt and enter the verification code below.{' '}
        <a href="/" target="_blank" rel="noreferrer">
          Why Do I Need To Do This?
        </a>
      </styled.SubTitle>
      {inputs(properties, formik)}
      <Terms mt="30px" />
      <ModalActions>
        <Button size={ButtonSize.DEFAULT} color={ButtonColor.SECONDARY} onClick={close}>
          Cancel
        </Button>
        <Button size={ButtonSize.DEFAULT} onClick={formik.submitForm} loading={wait}>
          Continue
        </Button>
      </ModalActions>
    </>
  )
}
